var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-end":"","align-center":""}},[_c('v-flex',[_c('h2',{staticClass:"display-2 display-2_dark"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),(!_vm.executed)?_c('v-flex',{attrs:{"shrink":""}},[_c('v-icon',{staticClass:"clickable",attrs:{"large":""},on:{"click":_vm.close}},[_vm._v(" clear ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }